import React, { useMemo } from 'react';
import { Text } from '@moda/om';
import { SECONDS_TO_MILLISECONDS, useTimer } from '@moda/portal-stanchions';
import { LineItem } from '../../../hooks/useCart/cart.rest';

type Props = {
  item: LineItem;
  red?: boolean;
};

export const SavedLineItemSoldOut: React.FC<Props> = ({
  item: {
    attributes: { inventory, skuId, isSoldOut, activeEndAt },
    type
  },
  red = false
}) => {
  const isSizeSoldOut = useMemo(
    () => inventory.find(item => item.id === skuId)?.available === 0,
    [inventory, skuId]
  );

  const [timeLeft] = useTimer((activeEndAt || Infinity) * SECONDS_TO_MILLISECONDS);

  const buttonColor = red ? 'code-red' : 'cement';

  if (type === 'cart_items') return null;

  return (
    <div>
      {isSizeSoldOut && !isSoldOut && (
        <Text treatment="body2" color={buttonColor}>
          Size Sold Out
        </Text>
      )}
      {isSoldOut && (
        <Text treatment="body2" color={buttonColor}>
          Sold Out
        </Text>
      )}
      {timeLeft.isOver && (
        <Text
          treatment="body2"
          color={buttonColor}
          data-testid="SavedLineItemSoldOut--trunkshow-ended"
        >
          Trunkshow has ended
        </Text>
      )}
    </div>
  );
};
